import { get, set } from "lodash"

export class FileUploadSingleController {

  constructor($scope, $confirm) {
    this.$scope = $scope
    $scope.setValue = this.setValue.bind(this)
    $scope.clearValue = this.clearValue.bind(this)
    $scope.getValue = this.getValue.bind(this)
    this.$confirm = $confirm
  }

  clearValue() {
    this.$confirm({
      text: 'Are you sure you want to remove this file?'
    }).then(() => {
      this.setValue(undefined)
    })
  }

  getValue(){
    return get(this.$scope.model, this.$scope.options.key)
  }

  setValue(value) {
    set(this.$scope.model, this.$scope.options.key, value)
  }
}

FileUploadSingleController.$inject = ['$scope', '$confirm']